import { Box, Typography, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { TableSelectionProps } from './types';
import { WbButton } from '../WbButton';
import { CSSProperties } from 'react';

type WbTableSelectionStatusProps<T> = {
  className?: string;
  style?: CSSProperties;
} & TableSelectionProps<T>;

const useStyles = makeStyles(
  theme => ({
    flexBox: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
  }),
  { name: 'WbTableSelectionStatus' },
);

export function WbTableSelectionStatus<T>({
  className,
  style,
  selectedItems,
  clearSelection,
}: WbTableSelectionStatusProps<T>) {
  const classes = useStyles();

  if (!selectedItems.length) return null;

  return (
    <Box className={clsx(classes.flexBox, className)} style={style}>
      <Typography variant="body2" style={{ fontWeight: 'medium' }}>
        {selectedItems.length} Items selected
      </Typography>
      <WbButton
        variant="text"
        label="Clear selection"
        onClick={clearSelection}
      />
    </Box>
  );
}
